const simpleDataTypes = {
    PDF_REPORT: 'PDF_REPORT',
    ALL_FILES: 'ALL_FILES',
};

export default simpleDataTypes;
